import script from "./fiscal-years.vue?vue&type=script&setup=true&lang=js"
export * from "./fiscal-years.vue?vue&type=script&setup=true&lang=js"

import "./fiscal-years.vue?vue&type=style&index=0&id=266d6331&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266d6331"]])

export default __exports__